<div snPlayerPtz class="sn-data-list" *ngIf="fullscreen && ptzConfig && live && !ptzConfig.isCanon">
  <div class="preset-menu" *ngIf="isOpen">
    <button
      *ngIf="isOpen && presets?.length > 0 && !isEditing"
      class="gm-ui-hover-custom"
      (click)="close()"
      mat-icon-button
      matTooltip="Close Window"
    >
      <sn-icon id="closeBtn" fontIcon="fa-close" fontSet="fal"></sn-icon>
    </button>
    <ng-container *ngIf="!loadingPtz; else loading">
      <mat-table
        [dataSource]="presets"
        class="mat-elevation-z8"
        style="min-height: 300px"
        *ngIf="isOpen && presets?.length > 0 && !isEditing"
      >
        <div *ngIf="hasPresets">
          <ng-container matColumnDef="presetNumber">
            <mat-header-cell *matHeaderCellDef> No.</mat-header-cell>
            <mat-cell *matCellDef="let preset">{{ stripAlpha(preset.presetNumber) }}</mat-cell>
          </ng-container>
        </div>

        <ng-container matColumnDef="presetName">
          <mat-header-cell *matHeaderCellDef>Name</mat-header-cell>
          <mat-cell *matCellDef="let preset">
            <span *ngIf="preset.presetName !== ''">{{ preset.presetName }}</span>
            <span *ngIf="preset.presetName === ''">Untitled</span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
          <mat-cell *matCellDef="let preset">
            <sn-icon-button
              *ngIf="
                !ptzConfig.isAxis &&
                !ptzConfig.isSony &&
                !isExternalPtz &&
                ptzConfig?.external?.externalType?.toLowerCase() !== 'avigilon' &&
                canChangePresets
              "
              icon="create"
              color="success"
              (click)="editPreset(preset); $event.stopPropagation()"
            ></sn-icon-button>
            <sn-icon-button
              *ngIf="
                !isExternalPtz &&
                ptzConfig?.external?.externalType?.toLowerCase() !== 'avigilon' &&
                canChangePresets
              "
              mat-icon-button
              (click)="delete(preset); $event.stopPropagation()"
              color="warn"
              matTooltip="Delete Preset"
            >
              <sn-icon fontIcon="fa-trash-alt" fontSet="fal"> </sn-icon>
            </sn-icon-button>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let preset; columns: displayedColumns" (click)="goToPreset(preset)">
        </mat-row>
      </mat-table>
      <div class="no-presets" *ngIf="noPresets">
        <sn-icon-button
          *ngIf="noPresets"
          class="gm-ui-hover-custom"
          (click)="close()"
          mat-icon-button
          matTooltip="Close Window"
        >
          <sn-icon id="closeNoPresetBtn" fontIcon="fa-close" fontSet="fal"></sn-icon>
        </sn-icon-button>
        <p>No Presets Available</p>
        <div class="menuFooter" *ngIf="!isEditing && isOpen">
          <sn-icon-button
            *ngIf="
              isOpen &&
              !isEditing &&
              !isExternalPtz &&
              ptzConfig?.external?.externalType?.toLowerCase() !== 'avigilon' &&
              canChangePresets
            "
            mat-icon-button
            class="add-preset"
            (click)="this.editPreset({ presetName: '' })"
          >
            <sn-icon class="addPresetBtn" fontIcon="fa-plus" fontSet="fal"></sn-icon>
          </sn-icon-button>
        </div>
      </div>
    </ng-container>
    <div class="menuFooter" *ngIf="presets?.length > 0 && !isEditing && isOpen">
      <sn-icon-button
        *ngIf="
          isOpen &&
          !isEditing &&
          !isExternalPtz &&
          ptzConfig?.external?.externalType?.toLowerCase() !== 'avigilon' &&
          canChangePresets
        "
        (click)="this.editPreset({ presetName: '' })"
        matTooltip="Add Preset"
        mat-icon-button
      >
        <sn-icon class="addPresetBtn" fontIcon="fa-plus" fontSet="fal"></sn-icon>
      </sn-icon-button>
      <mat-paginator
        [length]="metaPagination?.totalCount || 0"
        [pageSizeOptions]="[5]"
        [pageIndex]="page"
        [pageSize]="5"
        (page)="onPagination($event)"
      >
      </mat-paginator>
    </div>
  </div>
  <mat-card id="editPreset" *ngIf="isEditing">
    <sn-icon-button
      class="gm-ui-hover-custom"
      (click)="cancelEdit()"
      mat-icon-button
      matTooltip="Close Window"
    >
      <sn-icon id="closeEditBtn" fontIcon="fa-close" fontSet="fal"></sn-icon>
    </sn-icon-button>
    <mat-card-header>
      <mat-card-title>Edit Preset</mat-card-title>
      <mat-card-subtitle>Save this current position as:</mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
      <form [formGroup]="form">
        <input type="text" formControlName="name" />
      </form>
    </mat-card-content>

    <mat-card-actions>
      <button mat-button (click)="savePreset()" color="success">Save</button>
      <button mat-button (click)="cancelEdit()" color="danger">Cancel</button>
    </mat-card-actions>
  </mat-card>

  <ng-template #loading>
    <div class="spinner-container">
      <mat-spinner [diameter]="48" [strokeWidth]="4" color="accent" class="spinner"></mat-spinner>
    </div>
  </ng-template>

  <div
    class="loading-overlay"
    *ngIf="isMoving || isSaving"
    [ngClass]="{ 'save-overlay': isSaving }"
  >
    <mat-spinner [diameter]="48" [strokeWidth]="4" color="accent" class="spinner"></mat-spinner>
  </div>
</div>
